import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck } from 'lucide-react';
export function Hero() {
  return <section className="relative bg-brand-primary text-white overflow-hidden" data-id="element-70">
      {/* Urgency Bar */}
      <div className="bg-brand-dark text-center py-2 px-4 text-sm font-medium flex items-center justify-center gap-2" data-id="element-71">
        <span className="animate-pulse" data-id="element-72">🚨</span>
        <span data-id="element-73">Atención: Solo quedan 23 copias con el 75% de descuento</span>
      </div>

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-24 text-center" data-id="element-74">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto" data-id="element-75">
          {/* Trust Badge */}
          <div className="flex items-center justify-center gap-2 mb-6" data-id="element-76">
            <div className="flex text-yellow-400" data-id="element-77">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-78" />)}
            </div>
            <span className="text-brand-bg/90 text-sm font-medium" data-id="element-79">
              4.9/5 (Más de 2,000 clientes felices)
            </span>
          </div>

          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight mb-6 leading-tight" data-id="element-80">
            Recetas Deliciosas para un{' '}
            <span className="text-brand-accent" data-id="element-81">Hígado Sano</span>
          </h1>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="mb-10 rounded-2xl overflow-hidden shadow-2xl ring-4 ring-white/10" data-id="element-82">
            <img src="https://cdn.magicpatterns.com/uploads/sv4PPPdd8k5sXGYK6SGgV6/nutricion_hook.webp" alt="Collage de recetas saludables y deliciosas para sanar el hígado graso: platos balanceados, snacks y postres ligeros." className="w-full h-auto object-cover" loading="eager" data-id="element-83" />
          </motion.div>

          <p className="text-lg md:text-xl text-brand-bg/90 mb-10 leading-relaxed" data-id="element-84">
            Come rico, cuida tu hígado y recupera tu energía — sin dietas
            aburridas ni sacrificios imposibles.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-85">
            <a href="https://noveliahub.com/cart/50878318477348:1" className="w-full sm:w-auto bg-orange-500 hover:bg-orange-600 text-white text-lg font-bold py-4 px-8 rounded-full shadow-[0_8px_30px_rgba(249,115,22,0.5)] transition-transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-orange-400/60 animate-pulse" data-id="element-86">
              Quiero mis recetas ahora
            </a>
          </div>

          <div className="mt-8 flex items-center justify-center gap-2 text-sm text-brand-bg/80" data-id="element-87">
            <ShieldCheck className="w-5 h-5 text-brand-accent" data-id="element-88" />
            <span data-id="element-89">Garantía de devolución de 60 días. Compra 100% segura.</span>
          </div>
        </motion.div>
      </div>

      {/* Decorative bottom curve */}
      <div className="absolute bottom-0 left-0 right-0 h-16 bg-brand-bg" style={{
      clipPath: 'polygon(0 100%, 100% 100%, 100% 0, 0 100%)'
    }} data-id="element-90"></div>
    </section>;
}